import { Link } from 'react-router-dom';

const steps = [
  {
    num: '01',
    icon: 'ri-discuss-line',
    title: '需求諮詢',
    desc: '由專業業務人員對焦產品需求、目標市場、預算規劃等合作方向',
  },
  {
    num: '02',
    icon: 'ri-file-list-3-line',
    title: '配方提案',
    desc: '根據配方需求，進行小批量試製確認品質與口感',
  },
  {
    num: '03',
    icon: 'ri-draft-line',
    title: '包裝設計',
    desc: '根據產品、配方原料性質，為產品量身打造包裝，提高產品的保存率',
  },
  {
    num: '04',
    icon: 'ri-test-tube-line',
    title: '檢驗認證',
    desc: '若有相關檢驗、授權申請需求，可協助送審',
  },
  {
    num: '05',
    icon: 'ri-file-check-line',
    title: '量產確認',
    desc: '試樣通過後，將進入生產排程、正式量產',
  },
  {
    num: '06',
    icon: 'ri-settings-3-line',
    title: '完成交貨',
    desc: '完成品質檢驗後，將依約定時程安排出貨',
  },
];

export default function CoopProcessSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            合作流程
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            六個步驟，從諮詢到出貨
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            清晰透明的合作流程，讓您每個階段都安心，輕鬆掌握產品進度
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {steps.map((s, idx) => (
            <div
              key={s.num}
              className="relative flex flex-col bg-[#f7faf7] rounded-2xl p-6 lg:p-7 border border-gray-100 hover:border-green-200 hover:-translate-y-1 transition-all duration-300 h-full"
            >
              {/* Step number badge */}
              <div className="flex items-center justify-between mb-4">
                <span className="text-[#4CAF50] font-bold text-[1.5rem] leading-none opacity-30">{s.num}</span>
                <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl border border-green-100 shrink-0">
                  <i className={`${s.icon} text-[#4CAF50] text-lg`} />
                </div>
              </div>
              <h3 className="text-[#1a2e1a] font-bold text-[1rem] mb-2">{s.title}</h3>
              <p className="text-gray-500 text-[0.875rem] leading-[1.75] flex-1">{s.desc}</p>
              {/* Arrow connector for lg */}
              {idx < steps.length - 1 && (idx + 1) % 3 !== 0 && (
                <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 items-center justify-center z-10">
                  <i className="ri-arrow-right-s-line text-green-300 text-xl" />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/contact/form"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
          >
            開始第一步 — 立即諮詢
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
